import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { GlobalService } from 'src/app/extensions/services/global.service';

@Component({
  selector: 'should-login',
  template: '',
  standalone: false,
})
export class ShouldLoginComponent implements OnInit {
  constructor(
    private _oauthService: OAuthService,
    private _cookieService: CookieService,
    private _globalService: GlobalService
  ) {}

  ngOnInit(): void {
    const additionlParams = {
      'ui-culture': this._globalService.language,
      'ui-culture-timestamp': this._globalService.languageTimestamp,
      appId: this._globalService.appId,
    };
    this.clearLocalStorageIdmCache();
    //ForcedRedirectToLogin
    this._oauthService.initCodeFlow('', additionlParams);
  }

  private clearLocalStorageIdmCache() {
    this._globalService.deleteAllLocalStorageExceptKeysToKeep();
    sessionStorage.clear();
    this._cookieService.deleteAll();
  }
}
